import React, { Component, Fragment } from "react";
import ReactGA from "react-ga";
import NavBarComponent from "../../utilerias/nav";
import MenuComponent from "../../utilerias/menu";
import ContactoComponent from "../componentes/contacto";
import RedesComponent from "../../utilerias/redesSociales";
import "./styles.css";

export class Contacto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guardarNuevoIdioma: true,
      idiomaNavegador: navigator.language || navigator.userLanguage,
      componente: "",
      statusMenu: false,
    };
  }

  UNSAFE_componentWillMount() {
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        this.setState({ componente: "contact him..." });
        this.setState({ guardarNuevoIdioma: false });
      } else {
        this.setState({ componente: "contáctalo..." });
        this.setState({ guardarNuevoIdioma: true });
      }
    } else {
      if (storage !== null && storage === false) {
        this.setState({ componente: "contáctalo..." });
        this.setState({ guardarNuevoIdioma: true });
      } else {
        this.setState({ componente: "contact him..." });
        this.setState({ guardarNuevoIdioma: false });
      }
    }
  }
  componentDidMount() {
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        document.getElementById("text-lang").innerHTML = "ENG";
      } else {
        document.getElementById("text-lang").innerHTML = "ESP";
      }
    } else {
      if (storage !== null && storage === false) {
        document.getElementById("text-lang").innerHTML = "ESP";
      } else {
        document.getElementById("text-lang").innerHTML = "ENG";
      }
    }
  }
  render() {
    const openNav = () => {
      ReactGA.event({
        category: "Button",
        action: "Se ha dado click en el apartado del nav",
      });
      this.setState({ statusMenu: true });
      const x = window.matchMedia("(max-width: 999px)");
      if (x.matches === true) {
        document.getElementById("myNav").style.height = "110%";
      } else {
        document.getElementById("myNav").style.height = "100%";
      }
      document.getElementsByTagName("html")[0].style.overflowY = "hidden";
      document.getElementById("myNav").style.overflowY = "auto";
    };

    const closeNav = () => {
      this.setState({ statusMenu: false });
      document.getElementsByTagName("html")[0].style.overflowY = "visible";
      document.getElementById("myNav").style.height = "0%";
    };
    const cambiarIdioma = () => {
      if (this.state.guardarNuevoIdioma) {
        this.setState({ guardarNuevoIdioma: false });
        this.setState({ componente: "contact him..." });
        localStorage.setItem("español", true);
        document.getElementById("text-lang").innerHTML = "ENG";
      } else {
        this.setState({ guardarNuevoIdioma: true });
        this.setState({ componente: "contáctalo..." });
        localStorage.setItem("español", false);
        document.getElementById("text-lang").innerHTML = "ESP";
      }
    };
    return (
      <Fragment>
        <div className="contacto-fondo">
          <NavBarComponent
            closeNav={closeNav}
            openNav={openNav}
            statusMenu={this.state.statusMenu}
            cambiarIdioma={cambiarIdioma}></NavBarComponent>
          <MenuComponent
            closeNav={closeNav}
            cambiarIdioma={this.state.guardarNuevoIdioma}
          ></MenuComponent>
          <ContactoComponent
            componente={this.state.componente}
            cambiarIdioma={this.state.guardarNuevoIdioma}
          ></ContactoComponent>
          <div className="footer-redes-contacto">
            <RedesComponent></RedesComponent>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Contacto;
